import LifeFileUploadSection from 'components/LifeFileUploadSection';
import { SPECIALTY_FILE_TYPES } from 'constants/fileTypes';

interface LifeAdditionalFileUploadProps {
  isLocked?: boolean;
}

const LifeAdditionalFileUpload = ({ isLocked = false }: LifeAdditionalFileUploadProps) => {
  return (
    <LifeFileUploadSection
      title="Additional Documents"
      fieldLabel="Additional Document"
      fileType="additional_document"
      fileTypeId={SPECIALTY_FILE_TYPES.TYPE_ADDITIONAL_DOCUMENT}
      badgeText="Additional Document"
      acceptedFileTypes=".pdf,.png,.jpg,.jpeg,.xlsx,.xls,.doc,.docx"
      infoAlertText="Upload any additional supporting documents for this life insurance application."
      sectionId="sectionLifeAdditionalFileUpload"
      isRequired={false}
      isLocked={isLocked}
    />
  );
};

export default LifeAdditionalFileUpload;

